import httpClient from './httpClient';

const Create = (model) => httpClient.post('/api/v2/ChatMessage/AddChatMessage', model);

const GetChatMessages = (model) => httpClient.post('/api/v2/ChatMessage/GetChatMessages', model);

const GetGuestMessages = (roomStayGuestId) => httpClient.get('/api/v2/ChatMessage/GetGuestMessages', { params: { roomStayGuestId: roomStayGuestId } });



export default {
  Create,
  GetChatMessages,
  GetGuestMessages
}



// WEBPACK FOOTER //
// ./src/api/chat-api.js